import {createAction} from 'redux-actions';
import axios from 'axios';
import {apiUrl} from './config';

export const SESSION_DEFAULT = 'SESSION_DEFAULT'
export const SESSION_LOGIN_START = 'SESSION_LOGIN_START';
export const SESSION_LOGIN_FINISH = 'SESSION_LOGIN_FINISH';
export const SESSION_LOGOUT_FINISH = 'SESSION_LOGOUT_FINISH';
export const SESSION_AGREE_TERM = 'SESSION_AGREE_TERM';
export const REFRESH_TOKEN = 'REFRESH_TOKEN'

export const loginStart = createAction(SESSION_LOGIN_START, (code) => {
  return {
    isFetchingSession: true,
    code: code
  }
});

export const login = createAction(SESSION_LOGIN_FINISH, loginData => {
  return axios.post(apiUrl + 'client/mfc_aggre/user', loginData)
    .then(function(res) {
      localStorage.setItem('mf_authorization', JSON.stringify(res.data.data))
      return res.data.data;
    })
});

export const logout = createAction(SESSION_LOGOUT_FINISH, () => {
  return axios.delete(apiUrl + '/mfc_aggre/user')
    .then((res) => {
      return res.data;
    });
});

export const defaultSession = createAction(SESSION_DEFAULT, (options) => {
  return options
});

export const agreeTerm = createAction(SESSION_AGREE_TERM, () => {
  return axios.put(apiUrl + 'client/terms/user')
    .then(function(res) {
      return res.data;
    })
});

export const refreshToken = createAction(REFRESH_TOKEN, (expires_in=7200) => {
  const mf_authorization = JSON.parse(localStorage.getItem('mf_authorization'))
  const refresh_token = mf_authorization && mf_authorization.access_token && mf_authorization.access_token.refresh_token

  if (!refresh_token)
    return

  return axios.post(apiUrl + 'client/sessions', {refresh_token: refresh_token, expires_in: expires_in})
    .then(function(res) {
      localStorage.setItem('mf_authorization', JSON.stringify(res.data.data))
      return res.data.data;
    })
    .catch(res => {
      return { error: res.response };
    });
});
